// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"70":"800442aa817391a3cd3b","627":"1c56c8afaa2b5323a93f","816":"29f3663b4529c712be68"}[chunkId] + ".js";
};